'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessCompare = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pageMeta = require('acq-components/lib/utils/pageMeta');

var _PageContent = require('../../../components/PageContent/PageContent');

var _SubNavWrapper = require('../../../components/SubNavWrapper/SubNavWrapper');

var _SubNavWrapper2 = _interopRequireDefault(_SubNavWrapper);

var _HeroBannerWrapper = require('../../../components/HeroBannerWrapper/HeroBannerWrapper');

var _HeroBannerWrapper2 = _interopRequireDefault(_HeroBannerWrapper);

var _CompareWrapper = require('../../../components/CompareWrapper/CompareWrapper');

var _CompareWrapper2 = _interopRequireDefault(_CompareWrapper);

var _RumTelemetryScript = require('../../../components/RumTelemetryScript/RumTelemetryScript');

var _RumTelemetryScript2 = _interopRequireDefault(_RumTelemetryScript);

var _withPageSetup = require('../../../decorators/withPageSetup');

var _stylesheet = require('./stylesheet');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BusinessCompare = exports.BusinessCompare = function BusinessCompare(_ref) {
  var _ref$pageStylesStr = _ref.pageStylesStr,
      pageStylesStr = _ref$pageStylesStr === undefined ? '' : _ref$pageStylesStr,
      _ref$seo = _ref.seo,
      seo = _ref$seo === undefined ? {} : _ref$seo;
  return _react2.default.createElement(
    'div',
    { className: 'business-page-styles compare-intl-page' },
    _react2.default.createElement(
      _pageMeta.PageMeta,
      seo,
      _react2.default.createElement(
        'style',
        null,
        _stylesheet.stylesheet + ' ' + pageStylesStr
      )
    ),
    _react2.default.createElement(
      _PageContent.PageContent,
      null,
      _react2.default.createElement(_SubNavWrapper2.default, { styles: _stylesheet.styles }),
      _react2.default.createElement(_HeroBannerWrapper2.default, { styles: _stylesheet.styles, namespace: 'hero-banner', isCompare: true }),
      _react2.default.createElement(_CompareWrapper2.default, { styles: _stylesheet.styles }),
      _react2.default.createElement(_RumTelemetryScript2.default, null)
    )
  );
};

exports.default = (0, _withPageSetup.withPageSetup)(BusinessCompare, { pageName: 'compare' });